import { render, staticRenderFns } from "./ModalHolidaysSummary.vue?vue&type=template&id=35a59fd7&"
import script from "./ModalHolidaysSummary.vue?vue&type=script&lang=js&"
export * from "./ModalHolidaysSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports